import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { LoaderService } from '../service/loader.service';
import { Message } from '../service/message.service';
import { RestService } from '../service/rest.service';

@Component({
  selector: 'app-example-monouse-component',
  template: `
  <div *transloco="let t"
  class="flex flex-wrap gap-5 gap-y-5 place-content-center my-10"
  >
   @for (bando of fatherContaierRef?.dataTable; track $index) {
    <div class="w-full rounded-[30px] bg-Swhite shadow-xl p-[25px] cursor-pointer">
        <div class="flex gap-5"><div class="font-kansas text-font24px aspect43:text-font32px font-semibold text-quaternary overflow-hidden text-ellipsis"
            [title]="bando.title">{{bando.title}}</div>
        <div class="border-green-400 bg-green-300 text-green-700 p-2 h-[30px] rounded-[8px] flex items-center font-bold ml-auto" [ngClass]="{'!border-red-400 !bg-red-300 !text-red-700': !bando.open}">{{bando.open ?'APERTO' : 'CHIUSO'}}</div>
        </div>
        <div
            class="mt-[10px] text-quaternary text-font16px aspect43:text-font18px overflow-y-scroll overflow-x-hidden custom-scroll-secondary">
            {{bando.soggettoConcedente}}<br>
            <span class="font-bold">Finalità:</span> {{bando.obiettivoFinalita}}
            <div class="flex flex-wrap gap-2 mt-4 mb-2">@for (label of bando.labels; track $index) {
                <div class="p-1 border-secondary border-[2px] rounded-[8px] text-font12px bg-primary text-white font-semibold">{{label}}</div>
                }
            </div>
        </div>
    
        <div class="mt-[10px] text-quaternary text-font16px"><span class="font-bold">Scadenza: </span>{{bando.endDate == null ?'Fino ad esaurimento fondi' :bando.endDate}}</div>
      <div class="flex gap-5 mt-5">  <div (click)="showModalVerification(bando)" style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);" class="min-w-[165px] px-5 font-medium h-[43px] cursor-pointer rounded-full bg-[#F1F5FF] text-font18px text-primary flex items-center place-content-center">Verifica dell’ammissibilità</div>
      </div>
    </div>
              }
              @if(fatherContaierRef?.dataTable.length == 0){
                <div  class="flex justify-center items-center py-16">
      <div class="
        w-full max-w-md
        rounded-3xl
        border border-blue-100
        bg-gradient-to-br from-white to-blue-50
        shadow-lg
        p-8
        text-center
    ">

        <!-- Icona -->
        <div class="
            mx-auto mb-5
            flex items-center justify-center
            w-20 h-20
            rounded-full
            bg-blue-100
            text-blue-600
        ">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
          </svg>
        </div>

        <!-- Titolo -->
        <h3 class="
            text-xl
            font-bold
            text-slate-800
            mb-2
        ">
          Nessun risultato trovato
        </h3>

        <!-- Descrizione -->
        <p class="
            text-slate-500
            text-sm
            leading-6
            mb-6
        ">
          Non ci sono elementi che corrispondono ai filtri selezionati.
          <!-- Prova a modificare i criteri di ricerca. -->
        </p>

        <!-- Badge informativo -->
        <!-- <div class="
            inline-flex
            items-center
            gap-2
            px-4 py-2
            rounded-full
            bg-blue-50
            text-blue-700
            text-sm
            font-medium
        ">
          <span class="w-2 h-2 rounded-full bg-blue-500"></span>
          Filtri attivi senza risultati
        </div> -->

      </div>
    </div>
              }
              @if(modalVerification){
                <div (click)="modalVerification = false" class="fixed top-0 left-0  !w-screen h-[5000px] flex place-content-center bg-black bg-opacity-35">
                  <div (click)="$event.stopPropagation()" class="min-w-[300px] h-fit mt-[300px] max-w-[400px] bg-white rounded-[20px] shadow-xl p-[25px]">
                    <div class="font-kansas text-font24px font-semibold text-quaternary overflow-hidden text-ellipsis">@if(accepted){Sei ammissibile per questo bando, clicca su partecipa per unirti al progetto}@if(!accepted){Non sei ammissibile per questo bando, clicca su contattaci per contattarci}</div>
                    @if(accepted){<div (click)="join(currentNotice.id)" style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);" class="w-[165px] ml-auto font-medium h-[43px] rounded-full bg-primary text-font18px cursor-pointer text-Swhite flex items-center place-content-center mt-10">Partecipa</div>}
                    @if(!accepted){<div (click)="goToContact()" style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);" class="w-[165px] ml-auto font-medium h-[43px] rounded-full bg-primary text-font18px cursor-pointer text-Swhite flex items-center place-content-center mt-10">Contattaci</div>}
                  </div>
                </div>
              }
  </div>
  `,
  styles: [],
  standalone: false,
})
export class BandiCardComponent implements OnInit {

  constructor(private host: ElementRef<HTMLElement>, private rest: RestService, private loader: LoaderService, private message: Message) { }

  @Input() fatherElement :any = {};
  @Input() fatherContaierRef: any;
  modalVerification = false
  currentNotice :any
  accepted = false

  ngOnInit(): void {
  }

  goToContact(){
    window.location.replace('contatti')
  }

  showModalVerification(bando:any){
    this.loader.on()
    this.currentNotice = bando
    this.rest.get('/notice/'+bando.id+'/evaluate').subscribe({
      next: (value: any) => {
        this.loader.off()
        if (value.success) {
          this.accepted = true
          this.modalVerification = true
        } else {
          this.accepted = false
          this.modalVerification = true
          this.message.showMessage('Non sei ammissibile per questo bando contattaci per rimediare','error')
        }
      },
      error:(value)=> {
        this.message.showMessage('Non sei ammissibile per questo bando','error')
        this.loader.off()
      },
    })
  }

  getDate(endDate: string) {
    return new Date(endDate).getDate() + '-' + (new Date(endDate).getMonth() + 1) + '-' + new Date(endDate).getFullYear()
  }

  showDetails(bando:any){
    this.fatherContaierRef.showDetails(bando)
  }

  join(id: number) {
    this.loader.on()
    this.modalVerification = false
    this.rest.get('/notice/join/' + id).subscribe({
      next: (value: any) => {
        this.message.showMessage('Ti sei unito al progetto', 'success')
        this.loader.off()
      },
      error: (value: any) => {
        if (value.status == 409) {
          this.message.showMessage(value.error.message, 'error')
        }
        this.loader.off()
      },
    })
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
